export const allowedTypes = {
    higher: 'Высшее образование',
    secondary: 'Среднее профессиональное образование',
    additional: 'Дополнительное образование, повышение квалификации',
};


const competenceLevelsMap = {
    [null]: {
        name: 'неизвестен',
        value: 0,
    },
    basic: {
        name: 'базовый',
        value: 1,
    },
    intermediate: {
        name: 'cредний',
        value: 2,
    },
    advanced: {
        name: 'уверенный',
        value: 3,
    },
};

const programTypeNames = {
    program: {
        higher: 'Высшее образование',
        additional: 'Дополнительное образование',
        secondary: 'Среднее профессиональное образование',
    },
    full_time: {
        additional: 'Мероприятие',
    },
    webinar: {
        rsv_webinar: 'Вебинар РСВ',
        additional: 'Вебинар',
    },
    course: {
        rsv_course: 'Онлайн-курс РСВ',
        additional: 'Онлайн-курс',
    },
};

function getEducationProgramTypeName(v) {
    return programTypeNames[v.entityType][v.educationType];
}

function getCompetenceLevel(v) {
    return competenceLevelsMap[v];
}

export { getEducationProgramTypeName, getCompetenceLevel };
